export default {
  data () {
    return {
      sort: '',
      sortStorageKey: ''
    }
  },
  methods: {
    /**
     * Initializes the sort state from localStorage, with an optional default,
     * and syncs the vs-table column UI sort icons.
     * @param {string} storageKey - Unique localStorage key for this table (e.g. 'work_orders_sort')
     * @param {string} defaultSort - Default sort value (e.g. '-shipment-date')
     * @param {string} [tableRef] - Optional ref name of the vs-table component
     */
    initSort (storageKey, defaultSort = '', tableRef = null) {
      this.sortStorageKey = storageKey
      const savedSort = localStorage.getItem(this.sortStorageKey)
      this.sort = (savedSort !== null && savedSort !== undefined) ? savedSort : defaultSort

      this.$nextTick(() => {
        this.syncTableSortUI(tableRef)
      })

      return this.sort
    },

    /**
     * Synchronizes the Vuesax vs-table and vs-th visual sort indicators (up/down arrow icons)
     * with the current this.sort state.
     * @param {string} [tableRef] - Optional ref of the vs-table
     */
    syncTableSortUI (tableRef) {
      if (!this.sort) return

      const isDesc = this.sort.startsWith('-')
      const sortKey = isDesc ? this.sort.substring(1) : this.sort
      const sortType = isDesc ? 'desc' : 'asc'
      const sortIndex = isDesc ? 2 : 1

      // 1. Locate the VsTable component instance
      let table = null
      if (tableRef && this.$refs[tableRef]) {
        table = this.$refs[tableRef]
      } else {
        // Look through refs
        for (const key in this.$refs) {
          const ref = this.$refs[key]
          if (ref && ref.$options && ref.$options.name === 'VsTable') {
            table = ref
            break
          }
        }
      }

      // If not in direct refs, recursively find VsTable in children
      if (!table) {
        const findVsTable = (vm) => {
          if (!vm || !vm.$children) return null
          for (const child of vm.$children) {
            if (child.$options && child.$options.name === 'VsTable') return child
            const nested = findVsTable(child)
            if (nested) return nested
          }
          return null
        }
        table = findVsTable(this)
      }

      if (!table) return

      // 2. Set vs-table internal sort state
      table.currentSortKey = sortKey
      table.currentSortType = sortType

      // 3. Set vs-th children sort index to display the proper arrow icon
      const updateTh = (vm) => {
        if (!vm || !vm.$children) return
        vm.$children.forEach(child => {
          if (child.$options && child.$options.name === 'VsTh') {
            if (child.sortKey === sortKey) {
              child.currentSort = sortIndex
            } else {
              child.currentSort = 0
            }
          }
          updateTh(child)
        })
      }
      updateTh(table)
    },

    /**
     * Handles table column sorting and persists selection to localStorage.
     * @param {string} key - Column sort key
     * @param {string} active - 'asc', 'desc', or null
     * @param {Function} [fetchCallback] - Optional fetch method to call after sort updates
     */
    handleSort (key, active, fetchCallback) {
      if (key) {
        this.sort = active ? `${active === 'desc' ? '-' : ''}${key}` : ''
        if (this.sortStorageKey) {
          if (this.sort) {
            localStorage.setItem(this.sortStorageKey, this.sort)
          } else {
            localStorage.removeItem(this.sortStorageKey)
          }
        }
        if (typeof fetchCallback === 'function') {
          fetchCallback()
        } else if (typeof this.fetchWorkOrderList === 'function') {
          this.fetchWorkOrderList()
        } else if (typeof this.fetchData === 'function') {
          this.fetchData()
        }
      }
    }
  }
}
